type Props = {
  className?: string;
};

const WarningSvg = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
        stroke="#8083A0"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path d="M12 8V12.6667" stroke="#8083A0" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12 16.666C12.5523 16.666 13 16.2183 13 15.666C13 15.1137 12.5523 14.666 12 14.666C11.4477 14.666 11 15.1137 11 15.666C11 16.2183 11.4477 16.666 12 16.666Z"
        fill="#8083A0"
      />
    </svg>
  );
};
export default WarningSvg;
